import { all, call, put, takeLatest } from "redux-saga/effects";
import { getCallQueueReportByRecordNameErrorAction, getCallQueueReportByRecordNameSuccessAction, getCallQueueReportErrorAction, getCallQueueReportSuccessAction, getReportActiveCallForAllQueueErrorAction, getReportActiveCallForAllQueueSuccessAction, getReportActivityCallQueueErrorAction, getReportActivityCallQueueSuccessAction, getReportCallQueueByDateErrorAction, getReportCallQueueByDateForListQueuesErrorAction, getReportCallQueueByDateForListQueuesSuccessAction, getReportCallQueueByDateSuccessAction, getWeeklyReportCallQueueErrorAction, getWeeklyReportCallQueueSuccessAction } from "../../actions/callQueueReportAction";
import { Types } from "../../types";
import { GetQueueCallReportResponse } from "../../types/callQueueReport/apiRequestType";
import { getCallQueueReport, getCallQueueReportByRecordName, getReportActiveCallForAllQueueRequest, getReportActiveCallQueueRequest, getReportCallQueueByDateForListQueuesRequest, getReportCallQueueByDateRequest, getWeeklyReportCallQueueRequest } from "../apiRequests/callQueueReport";
import { ReportCallQueueByDate } from "../../interfaces/callQueueReport";
import { getReportActiveCallForAllQueueSuccess } from "../../types/Queues/actionsType";
import { GetReportCallQueueByDateForListQueuesResponse } from "../../interfaces/queue";



function* getCallQueueReportHandler(action: any) {
    try {
        const response: { data: GetQueueCallReportResponse } = yield call(getCallQueueReport, action.payload.params)
        yield put(
            getCallQueueReportSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            getCallQueueReportErrorAction({
                error: error.message
            })
        )
    }
}



function* getCallQueueReportByRecordNameHandler(action: any) {
    try {
        const response: { data: GetQueueCallReportResponse } = yield call(getCallQueueReportByRecordName, action.payload.params)

        yield put(
            getCallQueueReportByRecordNameSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            getCallQueueReportByRecordNameErrorAction({
                error: error.message
            })
        )
    }
}

function* getReportCallQueueByDateRequestHandler(action: any) {
    try {

        const response: { data: ReportCallQueueByDate } = yield call(getReportCallQueueByDateRequest, action.payload)

        yield put(
            getReportCallQueueByDateSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            getReportCallQueueByDateErrorAction({
                error: error.message
            })
        )
    }
}


function* getReportActivityCallQueueRequestHandler(action: any) {

    try {
        const response: { data: any } = yield call(getReportActiveCallQueueRequest, action.payload)

        yield put(
            getReportActivityCallQueueSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            getReportActivityCallQueueErrorAction({
                error: error.message
            })
        )
    }
}


function* getWeeklyReportCallQueueRequestHandler(action: any) {

    try {
        const response: { data: any } = yield call(getWeeklyReportCallQueueRequest, action.payload)

        yield put(
            getWeeklyReportCallQueueSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            getWeeklyReportCallQueueErrorAction({
                error: error.message
            })
        )
    }
}

function* getReportCallQueueByDateForListQueuesRequestHandler(action: any) {

    try {
        const response: { data: GetReportCallQueueByDateForListQueuesResponse } = yield call(getReportCallQueueByDateForListQueuesRequest, action.payload)

        yield put(
            getReportCallQueueByDateForListQueuesSuccessAction(
                response.data
            )
        )
    } catch (error: any) {
        yield put(
            getReportCallQueueByDateForListQueuesErrorAction({
                error: error.message
            })
        )
    }
}


function* getReportActiveCallForAllQueueRequestHandler(action: any) {

    try {
        const response: { data: getReportActiveCallForAllQueueSuccess } = yield call(getReportActiveCallForAllQueueRequest, action.payload)

        yield put(
            getReportActiveCallForAllQueueSuccessAction(
                response.data
            )
        )
    } catch (error: any) {
        yield put(
            getReportActiveCallForAllQueueErrorAction({
                error: error.message
            })
        )
    }
}
function* callQueueReportSaga() {
    yield all([takeLatest(Types.GET_CALL_QUEUE_REPORT_REQUEST, getCallQueueReportHandler)]);
    yield all([takeLatest(Types.GET_CALL_QUEUE_BY_RECORD_NAME_REQUEST, getCallQueueReportByRecordNameHandler)]);
    yield all([takeLatest(Types.GET_REPORT_CALL_QUEUE_BY_DATE_REQUEST, getReportCallQueueByDateRequestHandler)]);
    yield all([takeLatest(Types.GET_REPORT_ACTIVITY_CALL_QUEUE_REQUEST, getReportActivityCallQueueRequestHandler)]);
    yield all([takeLatest(Types.GET_WEEKLY_REPORT_CALL_QUEUE_REQUEST, getWeeklyReportCallQueueRequestHandler)]);
    yield all([takeLatest(Types.GET_REPORT_CALL_QUEUE_BY_DATE_FOR_LIST_QUEUES_REQUEST, getReportCallQueueByDateForListQueuesRequestHandler)]);
    yield all([takeLatest(Types.GET_REPORT_ACTIVE_CALL_FOR_ALL_QUEUE_REQUEST, getReportActiveCallForAllQueueRequestHandler)]);



}

export default callQueueReportSaga